import { render, staticRenderFns } from "./AddressItemTemplate.vue?vue&type=template&id=121a2653&"
import script from "./AddressItemTemplate.vue?vue&type=script&lang=js&"
export * from "./AddressItemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports